// English-as-key dictionary. t(en) returns the Dutch string in nl mode, else the English key.
// Only STATIC UI strings live here. User-generated data (names, report text, serials) is never translated.
export const nl = {
  // Nav / shell
  "New Report": "Nieuw rapport",
  "New": "Nieuw",
  "Reports": "Rapporten",
  "Parts Book": "Onderdelenboek",
  "Parts Catalog": "Onderdelencatalogus",
  "Profile": "Profiel",
  "Admin": "Beheer",
  "Log out": "Uitloggen",
  "Field service reporting": "Buitendienstrapportage",
  "Loading…": "Laden…",
  "Loading...": "Laden...",

  // Trial / billing banner
  "Your last payment failed.": "Je laatste betaling is mislukt.",
  "Your free trial ends today.": "Je gratis proefperiode eindigt vandaag.",
  "Service agreement (NDA & AVG)": "Serviceovereenkomst (NDA & AVG)",
  "Sign the agreement to continue": "Onderteken de overeenkomst om verder te gaan",
  "Your free trial has ended. Before you can subscribe, your company must sign the service agreement covering the NDA and AVG (GDPR). One signature unblocks your whole company.": "Je gratis proefperiode is afgelopen. Voordat je een abonnement kunt nemen, moet je bedrijf de serviceovereenkomst ondertekenen die de NDA en AVG (GDPR) dekt. Eén handtekening deblokkeert je hele bedrijf.",
  "Choose your language": "Kies je taal",
  "English": "Engels",
  "Nederlands": "Nederlands",
  "Read the agreement (PDF)": "Lees de overeenkomst (PDF)",
  "I have read and agree to the NDA & AVG service agreement.": "Ik heb de NDA & AVG-serviceovereenkomst gelezen en ga ermee akkoord.",
  "Full name": "Volledige naam",
  "Enter your full legal name": "Vul je volledige juridische naam in",
  "Draw your signature": "Teken je handtekening",
  "Sign & continue": "Onderteken & ga verder",
  "Only your company's billing owner can sign the agreement.": "Alleen de facturatie-eigenaar van je bedrijf mag de overeenkomst ondertekenen.",
  "Please draw your signature.": "Teken alsjeblieft je handtekening.",
  "Agreement signed — continue to subscribe.": "Overeenkomst ondertekend — ga verder naar het abonnement.",
  "Agreement signed": "Overeenkomst ondertekend",
  "This agreement still needs to be signed by the billing owner.": "Deze overeenkomst moet nog door de facturatie-eigenaar worden ondertekend.",
  "Not signed yet": "Nog niet ondertekend",
  "View agreement (PDF)": "Bekijk overeenkomst (PDF)",
  "View signature": "Bekijk handtekening",
  "Signed by": "Ondertekend door",
  "on": "op",
  "Continue": "Doorgaan",
  "Your free trial ends in": "Je gratis proefperiode eindigt over",
  "day": "dag",
  "days": "dagen",
  "Subscribe now": "Nu abonneren",

  // Auth / login
  "Admin Sign in": "Beheerder inloggen",
  "Welcome back": "Welkom terug",
  "Super-admin control console": "Superbeheerderconsole",
  "Sign in to log a completed job to the office": "Log in om een afgeronde klus naar kantoor te sturen",
  "Email": "E-mail",
  "Password": "Wachtwoord",
  "Forgot password?": "Wachtwoord vergeten?",
  "Log In": "Inloggen",
  "Admin?": "Beheerder?",
  "Admin console": "Beheerconsole",
  "New to RV Service Tool?": "Nieuw bij RV Service Tool?",
  "Create an account": "Account aanmaken",
  "This account is not a super-admin.": "Dit account is geen superbeheerder.",
  "Too many attempts, please wait a few minutes.": "Te veel pogingen, wacht een paar minuten.",
  "Your company is awaiting administrator approval.": "Je bedrijf wacht op goedkeuring van de beheerder.",
  "Update password": "Wachtwoord bijwerken",
  "Set a new password": "Stel een nieuw wachtwoord in",
  "Your account requires a new password before continuing.": "Je account vereist een nieuw wachtwoord voordat je verdergaat.",
  "New password (10+ chars, letters & numbers)": "Nieuw wachtwoord (10+ tekens, letters en cijfers)",
  "Update & continue": "Bijwerken en doorgaan",
  "Two-factor": "Tweestapsverificatie",
  "Enter your code": "Voer je code in",
  "Enter one of your backup codes.": "Voer een van je back-upcodes in.",
  "Enter the 6-digit code from your authenticator app.": "Voer de 6-cijferige code uit je authenticator-app in.",
  "Verify": "Verifiëren",
  "Use authenticator app instead": "Gebruik in plaats daarvan de authenticator-app",
  "Use a backup code": "Gebruik een back-upcode",
  "Set up 2FA": "2FA instellen",
  "Scan this QR code": "Scan deze QR-code",
  "Open Google Authenticator or Authy, scan the code, then enter the 6-digit code to activate.": "Open Google Authenticator of Authy, scan de code en voer daarna de 6-cijferige code in om te activeren.",
  "Activate 2FA": "2FA activeren",
  "Backup codes": "Back-upcodes",
  "Save your backup codes": "Bewaar je back-upcodes",
  "Store these somewhere safe. Each can be used once if you lose your phone. They won't be shown again.": "Bewaar deze op een veilige plek. Elke code is één keer te gebruiken als je je telefoon verliest. Ze worden niet opnieuw getoond.",
  "I have saved my backup codes": "Ik heb mijn back-upcodes opgeslagen",
  "Continue": "Doorgaan",
  "Welcome,": "Welkom,",

  // Reports list
  "Service reports sent to the office": "Servicerapporten verstuurd naar kantoor",
  "Search customer, call ID, date...": "Zoek klant, oproep-ID, datum...",
  "No reports found.": "Geen rapporten gevonden.",
  "Call": "Oproep",
  "machine": "machine",
  "machines": "machines",
  "parts": "onderdelen",
  "Sent to": "Verstuurd naar",
  "office": "kantoor",

  // Report detail
  "Back": "Terug",
  "PDF": "PDF",
  "Parts .xlsx": "Onderdelen .xlsx",
  "Signature": "Handtekening",
  "Edit": "Bewerken",
  "Resend": "Opnieuw versturen",
  "Report re-sent to office": "Rapport opnieuw naar kantoor verstuurd",
  "Resend queued — email may take a moment.": "Opnieuw versturen in wachtrij — e-mail kan even duren.",
  "Customer & Call": "Klant en oproep",
  "Address": "Adres",
  "Contact person": "Contactpersoon",
  "Mechanic": "Monteur",
  "Machines": "Machines",
  "Machine": "Machine",
  "Serial:": "Serienummer:",
  "No parts added.": "Geen onderdelen toegevoegd.",
  "Hours": "Uren",
  "Trips": "Ritten",
  "Work Performed": "Uitgevoerd werk",
  "Customer Signature": "Handtekening klant",

  // New / edit report
  "Log a service call & its machines": "Registreer een serviceoproep en de machines",
  "Office accounts can view and re-send reports but cannot create them.": "Kantooraccounts kunnen rapporten bekijken en opnieuw versturen, maar niet aanmaken.",
  "Customer name": "Klantnaam",
  "Call ID": "Oproep-ID",
  "Date": "Datum",
  "Add another machine": "Nog een machine toevoegen",
  "Add hours entry": "Uren toevoegen",
  "Add trip": "Rit toevoegen",
  "Describe what was done during the job...": "Beschrijf wat er tijdens de klus is gedaan...",
  "Describe what was done...": "Beschrijf wat er is gedaan...",
  "Name of person signing": "Naam van ondertekenaar",
  "Clear signature": "Handtekening wissen",
  "Send to Office": "Naar kantoor sturen",
  "Office Recipient": "Kantoorontvanger",
  "No recipients yet. Add one in Profile → Recipients.": "Nog geen ontvangers. Voeg er een toe in Profiel → Ontvangers.",
  "Send Report to Office": "Rapport naar kantoor sturen",
  "Serial number": "Serienummer",
  "Part number": "Onderdeelnummer",
  "Name (optional)": "Naam (optioneel)",
  "Customer name is required": "Klantnaam is verplicht",
  "Add at least one part to a machine": "Voeg minstens één onderdeel toe aan een machine",
  "Select an office recipient": "Selecteer een kantoorontvanger",
  "Report sent to office": "Rapport naar kantoor verstuurd",
  "Part of the Pro package": "Onderdeel van het Pro-pakket",
  "Pro package": "Pro-pakket",
  "View report": "Rapport bekijken",
  "Navigate": "Navigeren",
  "You have unsaved changes to this job. Leave without saving?": "Je hebt niet-opgeslagen wijzigingen in deze opdracht. Verlaten zonder op te slaan?",
  "Planner notes": "Notities van de planner",
  "Only for you — not part of the report, PDF or email.": "Alleen voor jou — geen onderdeel van het rapport, de pdf of de e-mail.",
  "per user / month": "per gebruiker / maand",
  "Service reports": "Servicerapporten",
  "Parts books": "Onderdelenboeken",
  "Scanning": "Scannen",
  "PDF & Excel export": "Pdf- & Excel-export",
  "Team management": "Teambeheer",
  "Everything in Standard": "Alles uit Standard",
  "Machine checklists": "Machinechecklists",
  "Choose one plan for your whole company.": "Kies één plan voor je hele bedrijf.",
  "Current plan": "Huidig plan",
  "Pro (granted)": "Pro (gratis toegekend)",
  "Upgrade to Pro": "Upgraden naar Pro",
  "Switch back to Standard": "Terug naar Standard",
  "Plan changes are charged or credited pro rata on your next invoice right away.": "Planwijzigingen worden direct naar rato verrekend op je volgende factuur.",
  "You're now on Pro": "Je zit nu op Pro",
  "You're now on Standard": "Je zit nu op Standard",
  "Only the billing owner can change the plan.": "Alleen de betalingsverantwoordelijke kan het plan wijzigen.",
  "More": "Meer",
  "Search parts and drawings": "Onderdelen en tekeningen zoeken",
  "Machine history by serial number": "Machinehistorie per serienummer",
  "Your account and company settings": "Je account- en bedrijfsinstellingen",
  "Privacy policy": "Privacybeleid",
  "Terms and conditions": "Algemene voorwaarden",
  "Planning, Dashboard and Machine checklists are a paid add-on. Contact info@rvservicetool.nl to turn it on for your company.": "Planning, Dashboard en machinechecklists zijn een betaalde uitbreiding. Neem contact op met info@rvservicetool.nl om dit voor je bedrijf aan te zetten.",
  "Company": "Bedrijf",
  "Choose a company…": "Kies een bedrijf…",
  "Choose a company to view its dashboard.": "Kies een bedrijf om het dashboard te bekijken.",
  "Choose a company to view its planning.": "Kies een bedrijf om de planning te bekijken.",
  "Choose a company to edit its checklists.": "Kies een bedrijf om de checklists te bewerken.",
  "Planning": "Planning",
  "My jobs": "Mijn opdrachten",
  "Checklists": "Checklists",
  "Checklist": "Checklist",
  "Plan jobs for your mechanics": "Plan opdrachten voor je monteurs",
  "Your planned jobs": "Je geplande opdrachten",
  "New job": "Nieuwe opdracht",
  "Edit job": "Opdracht bewerken",
  "Save job": "Opdracht opslaan",
  "Job planned": "Opdracht gepland",
  "Job updated": "Opdracht bijgewerkt",
  "Job deleted": "Opdracht verwijderd",
  "Delete this job?": "Deze opdracht verwijderen?",
  "Day": "Dag",
  "Week": "Week",
  "Month": "Maand",
  "Planned": "Gepland",
  "In progress": "Bezig",
  "Done": "Klaar",
  "No jobs planned in this period.": "Geen opdrachten gepland in deze periode.",
  "No jobs planned for you in this period.": "Geen opdrachten voor jou gepland in deze periode.",
  "Start report": "Rapport starten",
  "Open report": "Rapport openen",
  "Choose a mechanic": "Kies een monteur",
  "Choose a date": "Kies een datum",
  "End time must be after start time": "Eindtijd moet na de begintijd liggen",
  "Start": "Begin",
  "End": "Einde",
  "Add machine": "Machine toevoegen",
  "Notes": "Notities",
  "Jobs planned": "Opdrachten gepland",
  "Jobs done": "Opdrachten klaar",
  "Open jobs": "Open opdrachten",
  "Jobs today": "Opdrachten vandaag",
  "One checklist template per machine type": "Eén checklistsjabloon per machinetype",
  "items": "punten",
  "No checklist items yet.": "Nog geen checklistpunten.",
  "e.g. Check oil level": "bijv. Oliepeil controleren",
  "Required": "Verplicht",
  "Add item": "Punt toevoegen",
  "Save checklist": "Checklist opslaan",
  "Checklist saved": "Checklist opgeslagen",
  "Every item needs a label": "Elk punt heeft een omschrijving nodig",
  "Note / value": "Notitie / waarde",
  "Add photo": "Foto toevoegen",
  "Required before sending": "Verplicht vóór verzenden",
  "Please choose an image": "Kies een afbeelding",
  "Photo is larger than 8 MB": "Foto is groter dan 8 MB",
  "Tick every required checklist item (*) before sending.": "Vink alle verplichte checklistpunten (*) aan voordat je verzendt.",
  "Filled in from a planned job. Sending this report marks the job as done.": "Ingevuld vanuit een geplande opdracht. Door dit rapport te verzenden wordt de opdracht afgerond.",
  "Reports are sent from RV Service Tool on your behalf, shown with your name, and replies come back to your email address.": "Rapporten worden namens jou verzonden via RV Service Tool, met jouw naam als afzender, en antwoorden komen terug op jouw e-mailadres.",
  "Sent to {office} — replies will reach {email}.": "Verzonden naar {office} — antwoorden komen binnen op {email}.",
  "Report saved. Office email may take a moment.": "Rapport opgeslagen. Kantoore-mail kan even duren.",
  "Report language": "Rapporttaal",
  "Edit Report": "Rapport bewerken",
  "Saving updates the report without re-emailing. Use Resend to email again.": "Opslaan werkt het rapport bij zonder opnieuw te e-mailen. Gebruik Opnieuw versturen om weer te e-mailen.",
  "Could not load report": "Kon rapport niet laden",
  "Report saved": "Rapport opgeslagen",
  "Save Changes": "Wijzigingen opslaan",

  // Parts book
  "Browse assemblies, drawings & spare parts": "Blader door samenstellingen, tekeningen en reserveonderdelen",
  "Accepted PDF format": "Geaccepteerd PDF-formaat",
  "One": "Eén",
  "file (up to 40 MB).": "bestand (tot 40 MB).",
  "Group parts by": "Groepeer onderdelen per",
  ", each on its own page(s).": ", elk op een eigen pagina('s).",
  "Give each assembly a parts table with": "Geef elke samenstelling een onderdelentabel met",
  "Position no.": "Positienr.",
  "(price optional).": "(prijs optioneel).",
  "An": "Een",
  "exploded-view drawing": "explosietekening",
  "page per assembly is optional — numbered callouts on it enable tap-to-select on the image.": "pagina per samenstelling is optioneel — genummerde verwijzingen erop maken tik-om-te-selecteren op de afbeelding mogelijk.",
  "Current book:": "Huidig boek:",
  "assemblies": "samenstellingen",
  "Processing the uploaded PDF…": "Geüploade PDF verwerken…",
  "No spare parts book uploaded yet.": "Nog geen onderdelenboek geüpload.",
  "Upload PDF": "PDF uploaden",
  "Delete": "Verwijderen",
  "Part number, description or assembly": "Onderdeelnummer, omschrijving of samenstelling",
  "No assemblies to show.": "Geen samenstellingen om te tonen.",
  "Parts book uploaded": "Onderdelenboek geüpload",
  "Pinch to zoom · tap a part number in the list": "Knijp om te zoomen · tik op een onderdeelnummer in de lijst",
  "Delete the current spare parts book?": "Het huidige onderdelenboek verwijderen?",
  "Already in report": "Al in rapport",
  "Deleted": "Verwijderd",
  "Zoom in": "Inzoomen",
  "Reset zoom": "Zoom herstellen",
  "Tap a part number to see its details.": "Tik op een onderdeelnummer om de details te zien.",
  "No parts listed.": "Geen onderdelen vermeld.",
  "Pos": "Pos",
  "was": "was",
  "Add to report": "Toevoegen aan rapport",
  "Added to report": "Toegevoegd aan rapport",

  // Parts catalog
  "Scannable QR codes for the mobile app.": "Scanbare QR-codes voor de mobiele app.",
  "Export .xlsx": "Exporteren .xlsx",
  "Import from Parts Book": "Importeren uit onderdelenboek",
  "Name": "Naam",
  "Part number required": "Onderdeelnummer verplicht",
  "Part added": "Onderdeel toegevoegd",
  "No parts yet. Add one or import from the parts book.": "Nog geen onderdelen. Voeg er een toe of importeer uit het onderdelenboek.",
  "Download QR": "QR downloaden",

  // Recipients
  "Office Recipients": "Kantoorontvangers",
  "Where completed reports get emailed.": "Waar afgeronde rapporten naartoe worden gemaild.",
  "Name and email required": "Naam en e-mail verplicht",
  "Recipient added": "Ontvanger toegevoegd",
  "Saved": "Opgeslagen",
  "Delete this recipient?": "Deze ontvanger verwijderen?",

  // Team
  "Manage Team": "Team beheren",
  "Team": "Team",
  "Users in": "Gebruikers in",
  "Close": "Sluiten",
  "Add": "Toevoegen",
  "Password (10+ chars, letters & numbers)": "Wachtwoord (10+ tekens, letters en cijfers)",
  "Create user": "Gebruiker aanmaken",
  "Fill all fields": "Vul alle velden in",
  "User created": "Gebruiker aangemaakt",
  "Delete this user?": "Deze gebruiker verwijderen?",
  "Reset 2FA? User re-enrolls on next login.": "2FA resetten? Gebruiker registreert opnieuw bij volgende login.",
  "2FA reset": "2FA gereset",
  "2FA on": "2FA aan",
  "2FA not set": "2FA niet ingesteld",
  "manager": "manager",
  "mechanic": "monteur",

  // Profile
  "Super Admin": "Superbeheerder",
  "Manager": "Manager",
  "Office": "Kantoor",
  "Subscription": "Abonnement",
  "Free trial": "Gratis proef",
  "Active": "Actief",
  "Expired": "Verlopen",
  "Included": "Inbegrepen",
  "Payment failed": "Betaling mislukt",
  "Canceled": "Geannuleerd",
  "Your manager handles billing.": "Je manager beheert de facturering.",
  "Online payments are not switched on yet.": "Online betalingen zijn nog niet ingeschakeld.",
  "Manage subscription": "Abonnement beheren",
  "Subscribe now ": "Nu abonneren ",
  "Default Office Recipient": "Standaard kantoorontvanger",
  "Pre-selected on new reports to save time.": "Vooraf geselecteerd op nieuwe rapporten om tijd te besparen.",
  "Default recipient updated": "Standaardontvanger bijgewerkt",
  "Free trial — ends": "Gratis proef — eindigt",
  "Active — renews": "Actief — verlengt",
  "Included by the platform": "Inbegrepen door het platform",
  "Last payment failed — please update billing": "Laatste betaling mislukt — werk je facturering bij",
  "Subscription canceled": "Abonnement geannuleerd",
  "Trial ended — subscribe to continue": "Proefperiode afgelopen — abonneer om verder te gaan",
  "est. first payment": "gesch. eerste betaling",
  "Spare Parts Book": "Onderdelenboek",
  "month": "maand",
  "Barcode Scans": "Barcodescans",
  "Log scanned parts to an office": "Log gescande onderdelen naar een kantoor",
  "Manage parts & QR codes": "Onderdelen en QR-codes beheren",
  "Add or edit recipients": "Ontvangers toevoegen of bewerken",
  "Upload & browse the parts book": "Onderdelenboek uploaden en bekijken",
  "Invite & manage users": "Gebruikers uitnodigen en beheren",
  "Super-Admin Console": "Superbeheerderconsole",
  "Cross-company control": "Bedrijfsoverstijgend beheer",
  "Manage Offices": "Kantoren beheren",

  // Subscribe / billing
  "Subscription required": "Abonnement vereist",
  "Your 7-day free trial has ended.": "Je gratis proefperiode van 7 dagen is afgelopen.",
  "Your last payment didn't go through.": "Je laatste betaling is niet gelukt.",
  "Your subscription has been canceled.": "Je abonnement is geannuleerd.",
  "You're on your free trial.": "Je zit in je gratis proefperiode.",
  "You're all set": "Je bent helemaal klaar",
  "Continue with RV Service Tool": "Ga verder met RV Service Tool",
  "Your access is active. Head back to your reports.": "Je toegang is actief. Ga terug naar je rapporten.",
  "Go to app": "Naar de app",
  "Subscribe to keep your whole team's access to reports, parts and delivery.": "Abonneer om de toegang van je hele team tot rapporten, onderdelen en levering te behouden.",
  "Seat-based plan": "Plan per gebruiker",
  "One-time setup": "Eenmalige installatie",
  "Per user / month": "Per gebruiker / maand",
  "user": "gebruiker",
  "users": "gebruikers",
  "in your company": "in je bedrijf",
  "Estimated first payment": "Geschatte eerste betaling",
  "Unlimited reports for your company": "Onbeperkt rapporten voor je bedrijf",
  "Spare parts book & QR scanning": "Onderdelenboek en QR-scannen",
  "Team & recipient management": "Team- en ontvangerbeheer",
  "Secure 2FA login": "Beveiligde 2FA-login",
  "Subscribe": "Abonneren",
  "Secure payment via Stripe. Cancel anytime.": "Veilige betaling via Stripe. Altijd opzegbaar.",
  "Online payments are not switched on yet. Please check back soon, or contact us at +31650825998.": "Online betalingen zijn nog niet ingeschakeld. Kom binnenkort terug of neem contact op via +31650825998.",
  "Your trial has ended — your manager handles billing. Please ask your manager to renew the subscription.": "Je proefperiode is afgelopen — je manager beheert de facturering. Vraag je manager om het abonnement te verlengen.",
  "Signed in as": "Ingelogd als",
  "Confirming your payment…": "Je betaling bevestigen…",
  "Please wait while we verify with Stripe.": "Even geduld terwijl we verifiëren met Stripe.",
  "You're subscribed!": "Je bent geabonneerd!",
  "Taking you to your reports…": "Je wordt naar je rapporten gebracht…",
  "Subscription active — welcome back!": "Abonnement actief — welkom terug!",
  "We couldn't confirm payment": "We konden de betaling niet bevestigen",
  "If you were charged, please try again in a moment.": "Als er is afgeschreven, probeer het zo dadelijk opnieuw.",
  "Back to subscribe": "Terug naar abonneren",

  // Common actions / toasts
  "Cancel": "Annuleren",
  "Save": "Opslaan",
  "Save changes": "Wijzigingen opslaan",
  "Something went wrong": "Er is iets misgegaan",
  "The payment server had a problem. Please try again in a moment.": "De betaalserver had een probleem. Probeer het zo dadelijk opnieuw.",
  "Could not start checkout": "Kon afrekenen niet starten",

  // Language selector
  "Language": "Taal",
  "English": "Engels",
  "Dutch": "Nederlands",

  // Dashboard
  "Dashboard": "Dashboard",
  "This week": "Deze week",
  "This month": "Deze maand",
  "Reports sent": "Rapporten verstuurd",
  "Hours logged": "Uren geregistreerd",
  "Km driven": "Km gereden",
  "Parts used": "Onderdelen gebruikt",
  "Your company at a glance": "Je bedrijf in één oogopslag",
  "View full dashboard": "Volledig dashboard bekijken",
  "This week so far": "Deze week tot nu toe",

  // Company branding
  "Company Branding": "Bedrijfslogo",
  "A wide/landscape logo looks best; it appears on report PDFs and office emails.": "Een breed/liggend logo werkt het best; het verschijnt op rapport-PDF's en kantoore-mails.",
  "Upload logo": "Logo uploaden",
  "Replace logo": "Logo vervangen",
  "Remove": "Verwijderen",
  "No logo uploaded yet.": "Nog geen logo geüpload.",
  "Logo updated": "Logo bijgewerkt",
  "Logo removed": "Logo verwijderd",
  "Please choose a PNG or JPG.": "Kies een PNG of JPG.",
  "Logo must be 2 MB or smaller.": "Logo moet 2 MB of kleiner zijn.",
  "Remove the company logo?": "Het bedrijfslogo verwijderen?",

  // Report status + filters (Batch 1 & 2)
  "Save as Draft": "Opslaan als concept",
  "Draft saved": "Concept opgeslagen",
  "Draft": "Concept",
  "Sent": "Verstuurd",
  "Acknowledged": "Bevestigd",
  "Status": "Status",
  "All": "Alle",
  "Today": "Vandaag",
  "Send to Office": "Naar kantoor sturen",
  "Acknowledge": "Bevestigen",
  "Acknowledged by": "Bevestigd door",
  "Report acknowledged": "Rapport bevestigd",
  "Export CSV": "CSV exporteren",
  "report": "rapport",
  "reports": "rapporten",
  "Machines": "Machines",
  "Machine history": "Machinegeschiedenis",
  "Machines used across your company's reports": "Machines uit de rapporten van je bedrijf",
  "No machines yet.": "Nog geen machines.",
  "Service history": "Servicegeschiedenis",
  "Parts used": "Onderdelen gebruikt",
  "No reports for this machine.": "Geen rapporten voor deze machine.",
  "last used": "laatst gebruikt",
  "Machine history isn't available yet.": "Machinegeschiedenis is nog niet beschikbaar.",
  "Machine Types": "Machinetypes",
  "Machine type": "Machinetype",
  "None": "Geen",
  "Default": "Standaard",
  "Add type": "Type toevoegen",
  "Manage book": "Boek beheren",
  "Type name": "Typenaam",
  "Manage machine types & their parts books": "Beheer machinetypes en hun onderdelenboeken",
  "No machine types yet.": "Nog geen machinetypes.",
  "Create a machine type first to upload a parts book.": "Maak eerst een machinetype aan om een onderdelenboek te uploaden.",
  "Delete this machine type and its parts book?": "Dit machinetype en het onderdelenboek verwijderen?",
  "A type with that name already exists.": "Er bestaat al een type met die naam.",
  "Type created": "Type aangemaakt",
  "Type renamed": "Type hernoemd",
  "Type deleted": "Type verwijderd",
};

export const dictionaries = { en: {}, nl };
